import "./BookAppointment.css";

const BookAppointment = () => {
   return (
<section class="contact-section" id="ba">
  <div class="contact-container">

    <h2>Queries</h2>
    <p>Get in touch with us.</p>

    <form class="contact-form" action="#" method="post">
      
      <div class="form-group">
        <input type="text" name="name" placeholder="Full Name" required/>
      </div>

      <div class="form-group">
        <input type="email" name="email" placeholder="Email Address" required/>
      </div>

      <div class="form-group">
        <input type="tel" name="phone" placeholder="Phone Number" required/>
      </div>

      <div class="form-group">
        <input type="text" name="subject" placeholder="Subject" required/>
      </div>

      <div class="form-group">
        <textarea name="message" placeholder="Your Message" required></textarea>
      </div>

      <button type="submit">Send Message</button>
    </form>

  </div>
</section>

   );
}

export default BookAppointment;